import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { POPUPS } from '@common/constants/popups';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';

import CountDownComponent from '../countDownClock';
import { CASHOUT_MONEY_CASH } from '../../../actions/actionTypes';

const CashoutByTicket = () => {
	const t = useTranslation();
	const dispatch = useDispatch();
	const [{ openPopup, closePopup }] = useContext(PopupContext);

	const cashoutByTicket = () => {
		dispatch({ type: CASHOUT_MONEY_CASH });
		closePopup();
	};

	return (
		<div className="popup-content popup-small">
			<h3 className="popup-title">{t('Cashout')}</h3>
			<div className="popup-main-content">
				<CountDownComponent second={30} />
				<div className="mini-logo-container" />
			</div>
			<div className="popup-actions">
				<button
					type="button"
					className="popup-confirm-button"
					onClick={cashoutByTicket}
				>
					{t('Yes')}
				</button>
				<button
					type="button"
					className="popup-cancel-button"
					onClick={closePopup}
				>
					{t('Cancel')}
				</button>
			</div>
		</div>
	);
};

export default CashoutByTicket;
